<template>
  <div
    class="callback-transaction__wrapper"
    v-if="isCallbackActive"
    v-click-outside="closePopup"
  >
    <div class="callback-transaction__header">
      <popup-close-button @click="closePopup"></popup-close-button>
    </div>
    <div class="callback-transaction__body">
      <div class="body-title">
        <span>Callback</span>
      </div>
      <div class="info-list" v-if="callbackInformation.events.length !== 0">
        <div class="start-block" v-if="callbackInformation.events.start">
          <div
            class="start-block__header"
            :class="{ active: isStartBlockActive }"
          >
            <div class="left-side">
              <div class="title">
                <span>Старт</span>
              </div>
              <div class="collapse-button">
                <arrow-button
                  :class="{ 'is-open': isStartActive }"
                  @click="showStartBlock"
                ></arrow-button>
              </div>
            </div>
            <div class="right-side">
              <div class="status">
                <span>Статус:</span><span class="response">10 Started</span>
              </div>
            </div>
          </div>
          <div
            class="start-block__body"
            v-if="isStartBlockActive"
            :class="{ active: isStartBlockActive }"
          >
            <div class="body">
              <div class="label">
                <span>Дата:</span>
              </div>
              <div class="value">
                <span>{{
                  formattedTimestamp(callbackInformation.events.start.timestamp)
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="https-block" v-if="callbackInformation.events.request">
          <div
            class="https-block__header"
            :class="{ active: isHttpsBlockActive }"
          >
            <div class="left-side">
              <div class="title">
                <span>HTTP (S)</span>
              </div>
              <div class="collapse-button">
                <arrow-button
                  :class="{ 'is-open': isHttpsActive }"
                  @click="showHttpsBlock"
                ></arrow-button>
              </div>
            </div>
            <div class="right-side">
              <div class="status">
                <span>Статус:</span
                ><span class="response"
                  >{{ callbackInformation.events.request.statusCode }}
                  {{ callbackInformation.events.request.status }}</span
                >
              </div>
            </div>
          </div>
          <div
            class="https-block__body"
            v-if="isHttpsBlockActive"
            :class="{ active: isHttpsBlockActive }"
          >
            <div class="list">
              <div class="body">
                <div class="label">
                  <span>Адреса:</span>
                </div>
                <div class="value">
                  <span
                    >({{ callbackInformation.events.request.method }})
                    {{ callbackInformation.events.request.callbackURL }}</span
                  >
                </div>
              </div>
              <div class="body">
                <div class="label">
                  <span>Відповідь:</span>
                </div>
                <div class="value">
                  <span
                    >{{ callbackInformation.events.request.statusCode }}
                    {{ callbackInformation.events.request.status }}</span
                  >
                </div>
              </div>
              <div class="body">
                <div class="label">
                  <span>Дата:</span>
                </div>
                <div class="value">
                  <span>{{
                    formattedTimestamp(
                      callbackInformation.events.request.timestamp
                    )
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="response-block" v-if="callbackInformation.events.response">
          <div
            class="response-block__header"
            :class="{ active: isResponseBlockActive }"
          >
            <div class="left-side">
              <div class="title">
                <span>Відповідь API</span>
              </div>
              <div class="collapse-button">
                <arrow-button
                  :class="{ 'is-open': isResponseActive }"
                  @click="showResponseBlock"
                ></arrow-button>
              </div>
            </div>
            <div class="right-side">
              <div class="status">
                <span>Статус:</span><span class="response">10 Finish</span>
              </div>
            </div>
          </div>
          <div
            class="response-block__body"
            v-if="isResponseBlockActive"
            :class="{ active: isResponseBlockActive }"
          >
            <div class="list">
              <div class="body">
                <div class="label">
                  <span>Відповідь:</span>
                </div>
                <div class="value">
                  <span>{{
                    callbackInformation.events.response.response
                  }}</span>
                </div>
              </div>
              <div class="body">
                <div class="label">
                  <span>Дата:</span>
                </div>
                <div class="value">
                  <span>{{
                    formattedTimestamp(
                      callbackInformation.events.response.timestamp
                    )
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="address-callback-block" v-if="isAddressCallbackBlockActive">
        <div
          class="address-callback-block__header"
          :class="{ active: isAddressCallbackBlockActive }"
        >
          <div class="left-side">
            <div class="title">
              <span>Адреси callback</span>
            </div>
            <div class="collapse-button">
              <arrow-button
                :class="{ 'is-open': isAddressCallbackActive }"
                @click="showAddressCallbackBlock"
              ></arrow-button>
            </div>
          </div>
          <div class="right-side">
            <div class="status">
              <span>Статус:</span><span class="response">10 Finish</span>
            </div>
          </div>
        </div>
        <div
          class="address-callback-block__body"
          v-if="isAddressCallbackActive"
          :class="{ active: isAddressCallbackActive }"
        >
          <div class="list">
            <div
              class="body"
              v-if="callbackInformation.callbackAddresses.success"
            >
              <div class="label">
                <span>Запит при успіху:</span>
              </div>
              <div class="value">
                <span>{{ callbackInformation.callbackAddresses.success }}</span>
              </div>
            </div>
            <div class="body" v-if="callbackInformation.callbackAddresses.fail">
              <div class="label">
                <span>Запит при помилці:</span>
              </div>
              <div class="value">
                <span>{{ callbackInformation.callbackAddresses.fail }}</span>
              </div>
            </div>
            <div
              class="body"
              v-if="callbackInformation.callbackAddresses.gateParams"
            >
              <div class="label">
                <span>Параметри гейту:</span>
              </div>
              <div class="value">
                <span>{{
                  callbackInformation.callbackAddresses.gateParams
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-list__no-info" v-else>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="167"
          height="147"
          viewBox="0 0 167 147"
          fill="none"
        >
          <g opacity="0.5" clip-path="url(#clip0_9307_84451)">
            <path
              d="M18.618 129.12C18.618 129.12 -5.74519 113.632 1.29594 98.1015C5.39966 88.9657 23.3265 92.359 21.4258 77.1761C18.9636 57.2513 -0.691129 43.8086 10.6265 26.755C22.2897 9.17938 51.491 30.1483 79.9579 11.5721C98.3598 -0.435006 131.103 -7.13462 142.982 11.9201C154.343 30.1483 131.665 50.3777 148.123 63.9944C164.581 77.6112 183.415 98.1451 141.816 122.333C100.217 146.521 66.9123 127.858 66.9123 127.858"
              fill="#CBE6FF"
            />
            <path
              d="M31.534 14.0519C32.7003 17.4887 46.9122 17.2712 54.2557 15.9661C61.5992 14.7044 62.2903 12.0507 57.7114 9.00542C53.0894 5.96014 29.3309 7.43928 31.534 14.0519Z"
              fill="#CBE6FF"
            />
            <path
              d="M70.3247 10.0059C67.0849 7.74369 60.6054 14.0953 66.653 14.0953C72.6573 14.0518 72.5278 11.572 70.3247 10.0059Z"
              fill="#CBE6FF"
            />
            <path
              d="M15.6805 48.7246C11.3607 48.0285 15.4213 60.7752 21.5553 59.122C27.7324 57.4689 19.309 49.2901 15.6805 48.7246Z"
              fill="#E2F1FF"
            />
            <path
              d="M13.3047 41.5029C10.8424 42.4164 11.6632 47.8109 15.3349 46.6363C18.9635 45.5052 15.7237 40.6328 13.3047 41.5029Z"
              fill="#E2F1FF"
            />
            <path
              d="M80.2167 81.7876L80.7783 77.6112C81.0807 75.3925 79.6552 73.5653 77.6249 73.5653H44.4063L43.3264 81.7876L42.6784 86.8775L36.3717 134.471C35.6805 139.648 38.9635 143.868 43.7152 143.868H116.286C120.995 143.868 125.401 139.648 126.092 134.471L133.004 81.7876H80.2167Z"
              fill="#78A9DB"
            />
            <path
              d="M106.524 92.185C91.189 83.0492 75.854 73.9568 60.519 64.821C82.4632 52.7704 71.3183 21.056 93.2624 9.00537C108.597 18.1412 123.932 27.2335 139.267 36.3694C117.323 48.42 128.468 80.1344 106.524 92.185Z"
              fill="white"
            />
            <path
              d="M96.4161 54.9021C90.4981 51.3783 84.5801 47.8545 78.6621 44.3307C81.6427 33.3677 83.1546 21.5781 91.8804 14.0519C97.7984 17.5757 103.716 21.0995 109.634 24.6234C100.909 32.193 99.3967 43.9826 96.4161 54.9021Z"
              fill="#D9D9D9"
            />
            <path
              d="M129.764 39.5886C123.5 35.8473 117.236 32.1059 110.93 28.4081C111.534 27.7555 112.139 27.1465 112.83 26.5809C119.094 30.3223 125.358 34.0636 131.664 37.7615C130.973 38.327 130.368 38.9361 129.764 39.5886Z"
              fill="#C7D0FF"
            />
            <path
              d="M88.1652 53.1619C84.7526 51.1172 81.2968 49.0725 77.8843 47.0279C78.0571 46.5058 78.1867 45.9403 78.3594 45.4182C81.772 47.4629 85.2278 49.5076 88.6404 51.5523C88.4676 52.0743 88.338 52.6399 88.1652 53.1619Z"
              fill="#868686"
            />
            <path
              d="M95.1632 59.122C89.2452 55.5982 83.3272 52.0743 77.4092 48.5505C77.4956 48.2895 77.582 48.0285 77.6684 47.7675C83.5864 51.2913 89.5044 54.8151 95.4224 58.3389C95.336 58.6 95.2496 58.861 95.1632 59.122Z"
              fill="#D9D9D9"
            />
            <path
              d="M94.6446 60.6011C88.7266 57.0773 82.8086 53.5535 76.8906 50.0297C76.977 49.7686 77.0634 49.5076 77.1498 49.2466C83.0678 52.7704 88.9858 56.2942 94.9038 59.8181C94.8606 60.0791 94.7742 60.3401 94.6446 60.6011Z"
              fill="#D9D9D9"
            />
            <path
              d="M125.747 45.1572C119.483 41.4159 113.22 37.6746 106.913 33.9767C106.999 33.8027 107.086 33.6287 107.215 33.4982C113.479 37.2395 119.743 40.9809 126.049 44.6787C125.963 44.8092 125.833 44.9832 125.747 45.1572Z"
              fill="#D9D9D9"
            />
            <path
              d="M124.407 47.8544C118.144 44.1131 111.88 40.3717 105.573 36.6739C105.66 36.4999 105.746 36.3259 105.832 36.1519C112.096 39.8932 118.36 43.6345 124.666 47.3324C124.58 47.5064 124.494 47.6804 124.407 47.8544Z"
              fill="#D9D9D9"
            />
            <path
              d="M123.241 50.6822C116.978 46.9408 110.714 43.1995 104.407 39.5017C104.494 39.3276 104.537 39.1536 104.623 38.9796C110.887 42.721 117.15 46.4623 123.457 50.1601C123.414 50.3342 123.328 50.5082 123.241 50.6822Z"
              fill="#D9D9D9"
            />
            <path
              d="M122.248 53.5969C115.984 49.8556 109.721 46.1142 103.414 42.4164C103.457 42.2424 103.544 42.0248 103.587 41.8508C109.85 45.5922 116.114 49.3335 122.421 53.0314C122.378 53.2054 122.334 53.4229 122.248 53.5969Z"
              fill="#D9D9D9"
            />
            <path
              d="M121.384 56.5987C115.12 52.8574 108.857 49.1161 102.55 45.4182C102.593 45.2442 102.636 45.0267 102.723 44.8527C108.986 48.594 115.25 52.3354 121.557 56.0332C121.513 56.2072 121.427 56.3812 121.384 56.5987Z"
              fill="#D9D9D9"
            />
            <path
              d="M120.606 59.6006C114.343 55.8592 108.079 52.1179 101.772 48.42C101.816 48.246 101.859 48.0285 101.902 47.8545C108.166 51.5958 114.429 55.3372 120.736 59.035C120.693 59.2525 120.65 59.4266 120.606 59.6006Z"
              fill="#D9D9D9"
            />
            <path
              d="M119.829 62.6893C113.565 58.948 107.302 55.2066 100.995 51.5088C101.038 51.3348 101.082 51.1173 101.125 50.9432C107.388 54.6846 113.652 58.4259 119.959 62.1238C119.915 62.2978 119.872 62.4718 119.829 62.6893Z"
              fill="#D9D9D9"
            />
            <path
              d="M119.051 65.7346C112.787 61.9933 106.524 58.2519 100.217 54.5541C100.26 54.3801 100.303 54.1625 100.346 53.9885C106.61 57.7299 112.874 61.4712 119.18 65.1691C119.18 65.3431 119.137 65.5606 119.051 65.7346Z"
              fill="#D9D9D9"
            />
            <path
              d="M118.273 68.7799C112.01 65.0385 105.746 61.2972 99.4395 57.5994C99.4827 57.4253 99.5259 57.2078 99.6122 57.0338C105.876 60.7752 112.139 64.5165 118.446 68.2143C118.36 68.3884 118.317 68.5624 118.273 68.7799Z"
              fill="#D9D9D9"
            />
            <path
              d="M117.366 71.7381C111.103 67.9968 104.839 64.2555 98.5322 60.5576C98.5754 60.3836 98.6618 60.1661 98.705 59.9921C104.969 63.7334 111.232 67.4748 117.539 71.1726C117.496 71.3901 117.453 71.5641 117.366 71.7381Z"
              fill="#D9D9D9"
            />
            <path
              d="M116.373 74.6529C110.109 70.9116 103.846 67.1702 97.5391 63.4724C97.6255 63.2983 97.6687 63.1243 97.755 62.9503C104.019 66.6917 110.282 70.433 116.589 74.1308C116.503 74.3049 116.459 74.4789 116.373 74.6529Z"
              fill="#D9D9D9"
            />
            <path
              d="M115.207 77.4807C108.943 73.7393 102.68 69.998 96.373 66.3001C96.4594 66.1261 96.5458 65.9521 96.589 65.7781C102.853 69.5194 109.116 73.2608 115.423 76.9586C115.337 77.1326 115.293 77.3066 115.207 77.4807Z"
              fill="#D9D9D9"
            />
            <path
              d="M41.6851 103.148H106.351L113.176 30.7139H48.5102L41.6851 103.148Z"
              fill="#D9D9D9"
            />
            <path
              d="M40.519 102.887H105.185L110.974 28.5822H46.2643L40.519 102.887Z"
              fill="#82A5FF"
            />
            <path
              d="M39.2661 100.494H104.926L109.721 26.1895H52.5276L39.2661 100.494Z"
              fill="#C7D0FF"
            />
            <path
              d="M105.531 103.061H40.8213V32.4106L48.64 24.5798H105.531V103.061Z"
              fill="white"
            />
            <path
              d="M70.2384 30.7139H45.2705V70.4765H70.2384V30.7139Z"
              fill="#D9D9D9"
            />
            <path
              d="M101.297 30.7139H74.8174V33.8027H101.297V30.7139Z"
              fill="#C7D0FF"
            />
            <path
              d="M101.297 41.4159H74.8174V42.112H101.297V41.4159Z"
              fill="#D9D9D9"
            />
            <path
              d="M101.297 45.0702H74.8174V45.7663H101.297V45.0702Z"
              fill="#D9D9D9"
            />
            <path
              d="M101.297 48.7246H74.8174V49.4207H101.297V48.7246Z"
              fill="#D9D9D9"
            />
            <path
              d="M101.297 52.3789H74.8174V53.075H101.297V52.3789Z"
              fill="#D9D9D9"
            />
            <path
              d="M101.297 56.0332H74.8174V56.7293H101.297V56.0332Z"
              fill="#D9D9D9"
            />
            <path
              d="M101.297 59.6875H74.8174V60.3836H101.297V59.6875Z"
              fill="#D9D9D9"
            />
            <path
              d="M101.297 63.3419H74.8174V64.038H101.297V63.3419Z"
              fill="#D9D9D9"
            />
            <path
              d="M101.297 66.9962H74.8174V67.6923H101.297V66.9962Z"
              fill="#D9D9D9"
            />
            <path
              d="M101.297 70.6505H74.8174V71.3466H101.297V70.6505Z"
              fill="#D9D9D9"
            />
            <path
              d="M101.297 74.3049H74.8174V75.001H101.297V74.3049Z"
              fill="#D9D9D9"
            />
            <path
              d="M101.297 77.9592H74.8174V78.6553H101.297V77.9592Z"
              fill="#D9D9D9"
            />
            <path
              d="M101.297 81.6571H74.8174V82.3532H101.297V81.6571Z"
              fill="#D9D9D9"
            />
            <path
              d="M105.487 86.7905L73.3485 85.2243V82.3966C73.3485 80.0039 71.4046 78.0462 69.0288 78.0462L40.8643 78.0027V83.0056L76.8906 99.6242"
              fill="#D9D9D9"
            />
            <path
              d="M72.0527 86.8775V83.0492C72.0527 81.0045 70.4112 79.3513 68.3809 79.3513H35.1191V86.921V91.5759V135.254C35.1191 139.996 38.9637 143.868 43.6722 143.868H116.243C120.952 143.868 124.796 139.996 124.796 135.254V86.8775H72.0527Z"
              fill="#8CB3FD"
            />
            <path
              d="M96.1998 115.329C105.703 125.335 121.556 125.683 131.535 116.112C141.47 106.541 141.816 90.5754 132.313 80.5259C122.809 70.52 106.956 70.172 96.9773 79.7429C87.042 89.3573 86.6964 105.28 96.1998 115.329ZM101.383 84.3978C108.77 77.2631 120.563 77.5242 127.647 84.9634C134.732 92.4025 134.472 104.279 127.086 111.414C119.699 118.548 107.906 118.287 100.822 110.848C93.7376 103.409 93.9967 91.5325 101.383 84.3978Z"
              fill="#96B2FA"
            />
            <path
              opacity="0.19"
              d="M113.997 118.2C124.971 118.2 133.867 109.241 133.867 98.1886C133.867 87.1364 124.971 78.1768 113.997 78.1768C103.022 78.1768 94.126 87.1364 94.126 98.1886C94.126 109.241 103.022 118.2 113.997 118.2Z"
              fill="#006BFF"
            />
            <path
              opacity="0.35"
              d="M117.194 113.502C121.392 113.502 124.796 110.074 124.796 105.845C124.796 101.617 121.392 98.1885 117.194 98.1885C112.995 98.1885 109.591 101.617 109.591 105.845C109.591 110.074 112.995 113.502 117.194 113.502Z"
              fill="white"
            />
            <path
              opacity="0.35"
              d="M126.826 100.842C127.947 100.842 128.856 99.9269 128.856 98.7976C128.856 97.6684 127.947 96.7529 126.826 96.7529C125.705 96.7529 124.796 97.6684 124.796 98.7976C124.796 99.9269 125.705 100.842 126.826 100.842Z"
              fill="white"
            />
            <path
              opacity="0.35"
              d="M104.839 89.0093C106.481 87.3561 108.468 86.225 110.541 85.6595L108.554 82.0051C106.135 82.8317 103.889 84.1803 101.988 86.0945C95.379 92.7506 95.379 103.583 101.988 110.239L104.839 107.368C99.8283 102.278 99.8283 94.0557 104.839 89.0093Z"
              fill="white"
            />
            <path
              d="M97.2368 115.068C106.481 124.378 121.514 124.378 130.758 115.068C140.002 105.758 140.002 90.6189 130.758 81.3091C121.514 71.9992 106.481 71.9992 97.2368 81.3091C87.9927 90.6189 87.9927 105.758 97.2368 115.068ZM128.036 84.0498C135.812 91.8805 135.812 104.54 128.036 112.327C120.261 120.158 107.691 120.158 99.9583 112.327C92.1828 104.497 92.1828 91.837 99.9583 84.0498C107.691 76.2191 120.261 76.2191 128.036 84.0498Z"
              fill="#C7D0FF"
            />
            <g opacity="0.54">
              <path
                d="M117.193 85.5724C119.353 86.1379 121.427 87.269 123.111 88.9657L125.962 86.0944C123.457 83.5712 120.39 82.0051 117.193 81.396V85.5724Z"
                fill="white"
              />
            </g>
            <path
              d="M158.619 53.2489C160.865 55.5111 160.865 59.209 158.619 61.5147L141.686 78.5683L133.479 70.3025L150.412 53.2489C152.701 50.9432 156.373 50.9432 158.619 53.2489Z"
              fill="#C7D0FF"
            />
            <path
              d="M135.207 69.7805L142.161 76.7846C143.069 77.6982 143.069 79.1339 142.161 80.0474L137.842 84.3978C136.935 85.3114 135.509 85.3114 134.602 84.3978L127.647 77.3937C126.74 76.4801 126.74 75.0445 127.647 74.1309L131.967 69.7805C132.874 68.9104 134.343 68.9104 135.207 69.7805Z"
              fill="#FEFFD8"
            />
            <path
              d="M40.8213 32.4106L48.64 24.5798L47.3872 33.4111L40.8213 32.4106Z"
              fill="#D9D9D9"
            />
            <path
              d="M40.8213 32.4106L48.64 24.5798V32.4106H40.8213Z"
              fill="#EBE6FC"
            />
          </g>
          <defs>
            <clipPath id="clip0_9307_84451">
              <rect width="167" height="147" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <div class="no-info__text">
          {{ $t('callback-information.no-info') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import ArrowButton from '@vue-app/components/base/button/ArrowButton.vue'
import PopupCloseButton from '@vue-app/components/base/button/PopupCloseButton.vue'
import moment from 'moment/moment'

export default {
  name: 'CallbackTransactionPopup',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },

    callbackInformation: {
      type: [Object, Array],
      default: {} || [],
    },
  },
  components: {
    ArrowButton,
    PopupCloseButton,
  },
  data() {
    return {
      isCallbackActive: this.isActive,
      isHttpsActive: false,
      isHttpsBlockActive: false,
      isStartActive: false,
      isStartBlockActive: false,
      isResponseActive: false,
      isResponseBlockActive: false,
      isAddressCallbackActive: false,
      isAddressCallbackBlockActive: false,
    }
  },
  mounted() {
    this.checkBlocksAndSetActive()
  },
  methods: {
    formattedTimestamp(timestamp) {
      return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
    },
    closePopup() {
      this.isCallbackActive = false
      $emit(this, 'showCallback', false)
    },

    showStartBlock() {
      this.isStartActive = !this.isStartActive
      this.isStartBlockActive = !this.isStartBlockActive
    },

    showResponseBlock() {
      this.isResponseActive = !this.isResponseActive
      this.isResponseBlockActive = !this.isResponseBlockActive
    },

    showHttpsBlock() {
      this.isHttpsActive = !this.isHttpsActive
      this.isHttpsBlockActive = !this.isHttpsBlockActive
    },

    showAddressCallbackBlock() {
      this.isAddressCallbackActive = !this.isAddressCallbackActive
    },

    checkBlocksAndSetActive() {
      const hasStartInfo = Boolean(this.callbackInformation.events?.start)
      const hasHttpsInfo = Boolean(this.callbackInformation.events?.request)
      const hasResponseInfo = Boolean(this.callbackInformation.events?.response)
      const callbackAddresses = this.callbackInformation.callbackAddresses
      const hasNullValues = callbackAddresses && Object.values(callbackAddresses).every((value) => value === null)
      if (!hasNullValues) {
        this.isAddressCallbackBlockActive = true
        this.isAddressCallbackActive = true
      } else {
        this.isAddressCallbackBlockActive = false
        this.isAddressCallbackActive = false
      }

      const activeBlocks = [hasStartInfo, hasHttpsInfo, hasResponseInfo].filter(
        Boolean
      ).length

      if (activeBlocks === 3) {
        this.isResponseBlockActive = true
      } else if (activeBlocks === 2) {
        if (hasStartInfo && hasHttpsInfo) {
          this.isHttpsBlockActive = true
        } else if (hasStartInfo && hasResponseInfo) {
          this.isResponseBlockActive = true
        } else if (hasHttpsInfo && hasResponseInfo) {
          this.isResponseBlockActive = true
        }
      } else if (activeBlocks === 1) {
        if (hasStartInfo) {
          this.isStartBlockActive = true
        } else if (hasHttpsInfo) {
          this.isHttpsBlockActive = true
        } else if (hasResponseInfo) {
          this.isResponseBlockActive = true
        }
      }
    },
  },
  watch: {
    isActive(newValue) {
      this.isCallbackActive = newValue
    },

    callbackInformation: {
      deep: true,

      handler(newValue) {
        if (newValue.events) {
          this.checkBlocksAndSetActive()
        }
      },

      immediate: true,
    },
  },
  emits: ['showCallback'],
}
</script>

<style lang="scss" scoped>
.callback-transaction__wrapper {
  :deep(.arrow-button) {
    width: 18px;
    height: 18px;

    svg {
      width: 3px;
    }

    .popup-close-button {
      svg {
        stroke-width: 2;
      }
    }
  }

  position: fixed;
  top: 0;
  right: 0;
  width: 700px;
  height: 100%;
  border: 1px solid #8284a540;
  background-color: #fff;
  z-index: 999;
  .callback-transaction__header {
    padding: 20px;
  }
  .callback-transaction__body {
    padding: 20px 35px 30px 35px;
    .body-title {
      span {
        font-size: 20px;
        font-weight: 600;
        color: #585f6d;
        line-height: 24px;
      }
    }
    .label {
      padding: 12px 18px;
      width: 15%;
      border-right: 1px solid #e0e6f2;
      font-size: 12px;
      color: #b9c4d8;
      font-weight: 400;
      line-height: 18px;
    }
    .value {
      font-size: 12px;
      color: #1a1f29;
      font-weight: 400;
      line-height: 16px;
      padding-left: 10px;
      flex: 1;

      span {
        font-size: 11px;
      }
    }

    .right-side {
      font-size: 10px;
      line-height: 16px;
      font-weight: 400;
      color: #67768a;

      .response {
        font-size: 12px;
        color: #64748B;
        padding-left: 10px;
        font-weight: 500;
      }
    }

    .body {
      display: flex;
      align-items: center;
      border-top: 1px solid #e0e6f2;
      border-left: 1px solid #e0e6f2;
      border-right: 1px solid #e0e6f2;
      border-bottom: 1px solid #e0e6f2;
    }

    .info-list {
      margin-top: 20px;
      .start-block {
        .start-block__header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          padding: 15px;
          background-color: #fff;
          border-top: 1px solid #e0e6f2;
          border-right: 1px solid #e0e6f2;
          border-left: 1px solid #e0e6f2;
          border-bottom: 1px solid #e0e6f2;

          .left-side {
            display: flex;
            align-items: center;
            gap: 10px;

            .title {
              font-size: 14px;
              line-height: 20px;
              color: #68728c;
              font-weight: 600;
              text-transform: uppercase;
            }

            .collapse-button {
              .arrow-button {
                transition: transform 0.3s ease;
                transform: rotate(90deg);

                &.is-open {
                  transform: rotate(270deg);
                }
              }
            }
          }

          .right-side {
            display: none;
          }

          &.active {
            background-color: #f4f7ff;
            border-bottom: none;
            .title {
              font-weight: 700;
              color: #27365b;
            }
          }

          :deep(.arrow-button) {
            transition: transform 0.3s ease;
            transform: rotate(270deg);

            &.is-open {
              transform: rotate(90deg);
            }
          }
        }

        .start-block__body {
          border: none;
          &.active {
            .body {
              border-top: 1px solid #e0e6f2;
              border-left: 1px solid #e0e6f2;
              border-right: 1px solid #e0e6f2;
              border-bottom: 1px solid #e0e6f2;
            }
          }
        }
      }
      .https-block {
        .https-block__header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          padding: 15px;
          background-color: #fff;
          border-top: 1px solid #e0e6f2;
          border-right: 1px solid #e0e6f2;
          border-left: 1px solid #e0e6f2;
          border-bottom: 1px solid #e0e6f2;

          .left-side {
            display: flex;
            align-items: center;
            gap: 10px;

            .title {
              font-size: 14px;
              line-height: 20px;
              color: #68728c;
              font-weight: 600;
              text-transform: uppercase;
            }
          }

          &.active {
            background-color: #f4f7ff;

            .title {
              font-weight: 700;
              color: #27365b;
            }
          }

          :deep(.arrow-button) {
            transition: transform 0.3s ease;
            transform: rotate(90deg);

            &.is-open {
              transform: rotate(270deg);
            }
          }

          :deep(.arrow-button) {
            transition: transform 0.3s ease;
            transform: rotate(90deg);

            &.is-open {
              transform: rotate(270deg);
            }
          }
        }

        .https-block__body {
          border: none;

          &.active {
            .body {
              border-top: 1px solid #e0e6f2;
              border-left: 1px solid #e0e6f2;
              border-right: 1px solid #e0e6f2;
              border-bottom: none;
            }
          }
        }
      }
      .response-block {
        .response-block__header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          padding: 15px;
          background-color: #fff;
          border: 1px solid #e0e6f2;

          .left-side {
            display: flex;
            align-items: center;
            gap: 10px;

            .title {
              font-size: 14px;
              line-height: 20px;
              color: #68728c;
              font-weight: 600;
              text-transform: uppercase;
            }
          }

          .right-side {
            display: none;
          }

          &.active {
            background-color: #f4f7ff;

            .title {
              font-weight: 700;
              color: #27365b;
            }
          }

          :deep(.arrow-button) {
            transition: transform 0.3s ease;
            transform: rotate(270deg);

            &.is-open {
              transform: rotate(90deg);
            }
          }

          :deep(.arrow-button) {
            transition: transform 0.3s ease;
            transform: rotate(270deg);

            &.is-open {
              transform: rotate(90deg);
            }
          }
        }

        .response-block__body {
          border: none;

          &.active {
            .body {
              border-top: 1px solid #e0e6f2;
              border-left: 1px solid #e0e6f2;
              border-right: 1px solid #e0e6f2;
              border-bottom: none;

              &:last-child {
                border-bottom: 1px solid #e0e6f2;
              }
            }
          }
        }
      }
    }

    .info-list__no-info {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      background-color: #fff;
      border-radius: 8px;
      padding: 55px;
      gap: 30px;
      .no-info__text {
        width: 100%;
        text-align: center;
        color: #b9c4d8;
        font-size: 18px;
        font-weight: 600;
        line-height: 26px;
      }
    }

    .address-callback-block {
      margin-top: 30px;

      .address-callback-block__header {
        display: none;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 15px;
        background-color: #fff;

        .left-side {
          display: flex;
          align-items: center;
          gap: 10px;

          .title {
            font-size: 14px;
            line-height: 20px;
            color: #68728c;
            font-weight: 600;
            text-transform: uppercase;
          }
        }

        .right-side {
          display: none;
        }

        &.active {
          display: flex;
          .title {
            font-weight: 700;
            color: #27365b;
          }

          :deep(.arrow-button) {
            transition: transform 0.3s ease;
            transform: rotate(90deg);

            &.is-open {
              transform: rotate(270deg);
            }
            //transform: rotate(180deg);
          }
        }
      }

      .address-callback-block__body {
        border: none;

        .list {
          .body {
            .label {
              padding: 12px;
            }
          }
        }

        &.active {
          .body {
            border: 1px solid #e0e6f2;
          }
        }
      }
    }
  }
}
</style>
